(function (angular) {
    angular.module('app')
        .directive('postComment', postCommentDirective);

        postCommentDirective.$inject = [
        'UsersApi',
        'thisUser',
        'settings',
    ];

    function postCommentDirective (
        UsersApi,
        thisUser,
        settings,
    ) {
        function link($scope) {
            
            $scope.isReply = $scope.isReply || false;
            $scope.comment = $scope.comment || {};
            $scope.parent = $scope.parent || null;
            $scope.parentId = $scope.parentId || null;
            $scope.itemId = $scope.itemId;
            $scope.itemType = $scope.itemType;
            $scope.isLoading = true;
            $scope.replying = false;
            $scope.comment.itemId = $scope.itemId;

            $scope.rootElement = $scope.root;

            const comment = $scope.comment;
        
            $scope.getComments = $scope.getComments;
            $scope.updateComment = updateComment;
            $scope.reloadComments = reloadComments;

            $scope.showReplyBox = showReplyBox;
            $scope.hideReplyBox = hideReplyBox;
            $scope.cancelReply = cancelReply;
            $scope.saveReply = saveReply;

            $scope.showReplies = showReplies;
            $scope.hideReplies = hideReplies;

            $scope.editComment = editComment;
            $scope.cancelEdit = cancelEdit;

            $scope.deleteComment = $scope.deleteCommentFn || deleteComment;
            $scope.saveComment = $scope.saveCommentFn || saveComment;

            $scope.comment.editing = $scope.editMode || false;
            $scope.comment.deleting = false;
            $scope.repliesOpen = false;

            $scope.myComment = $scope.comment.user_id === thisUser.id;
            // $scope.isAdmin = true;
            
            $scope.editedComment = $scope.comment;

            const replyFormat = {
                parent_id: $scope.comment.id,
                body: '',
                entities: [],
                item_id: $scope.itemId,
                item_type: $scope.itemType,
            }

            $scope.reply = replyFormat;

            enum API_ROUTE {
                LIKES = '/api/likes',
                COMMENTS = '/api/comments',
            }

            function reloadComments() {
                // dispatches a custom event telling the poll.ts directive to re-fetch all comments
                document.body.dispatchEvent(new CustomEvent('comments:refresh'))
            }

            function markDeleted() {
                document.body.dispatchEvent(new CustomEvent('comments:delete', {
                    detail: { id: $scope.comment.id }
                }));
            }

            function showReplies() {
                $scope.repliesOpen = true;
            }

            function hideReplies() {
                $scope.repliesOpen = false;
            }

            function showReplyBox() {
                $scope.replying = true;
                $scope.reply.parent_id = $scope.comment.id;
            }

            function hideReplyBox() {
                $scope.replying = false;
            }

            function cancelReply() {
                $scope.replying = false;
                $scope.reply = replyFormat;
            }

            async function saveReply() {
                $scope.reply.saving = true;

                await $scope.updateComment('POST', $scope.reply).then(() => {
                    $scope.reply.saving = false;
                    $scope.reloadComments();
                })
            }

            function editComment() {
                $scope.comment.editing = true;
                $scope.editedComment = $scope.comment;
            }

            function cancelEdit() {
                $scope.comment.editing = false;
                $scope.editedComment = $scope.comment;
            }

            function saveComment() {
                const { id, body, entities } = $scope.editedComment;

                $scope.updateComment('PUT', { id, body, entities }).then(() => {
                    $scope.comment.editing = false;
                    $scope.reloadComments();
                })
            }

            async function updateComment(fetchMethod, commentData): Promise<any> {
                if (fetchMethod === 'GET') return false;
    
                const { id, item_id, parent_id, body, entities = [] } = commentData;
                let URL = `${API_ROUTE.COMMENTS}`;
                
                switch (fetchMethod.toUpperCase()) {
                    case 'DELETE':
                        URL += `/${id}`;
                        break;
                    case 'PUT':
                        URL += `/${id}?body=${body}`; // IMPLEMENT ENTITIES HERE
                        break;
                    case 'POST':
                        URL += `?item_id=${item_id}&item_type=${$scope.itemId}&item_id=${$scope.itemId}&body=${body}`;
                        if (parent_id) URL += `&parent_id=${parent_id}`;
                        break;
                    default:
                        throw Error('Unexpected fetchMethod parameter:' + fetchMethod);
                }
    
                const promise = await fetch(URL, { method: fetchMethod });
                return Promise.resolve(promise);
            }

            function deleteComment() {
                const _confirm = confirm('Are you sure you want to delete this?');
                if (_confirm) {
                    $scope.comment['deleting'] = true;

                    $scope.updateComment('DELETE', { id: comment.id }).then(() => {
                        $scope.comment['deleting'] = false;

                        const target = $scope.rootElement || document.body;

                        target.dispatchEvent(
                            new CustomEvent('comments:refresh', { detail: $scope.comment.id })
                        )
                    })
                }
            }

            function bootstrap() {
                $scope.isLoading = false;

                if ($scope.comment?.user) {
                    $scope.myComment = $scope.comment.user.id == thisUser.id;

                    if (!$scope.comment.parentId) {
                        $scope.showReplies();
                    }
                }
            }

            bootstrap();
        }

        return {
            restrict: 'E',
            templateUrl: 'directives/post-comment.html',
            transclude: true,
            replace: true,
            link: link,
            scope: {
                comment: '=?',
                parent: '=?',
                parentId: '=?',
                isReply: '=?',
                itemId: '=?',
                itemType: '=?',
                getComments: '&',
                updateComment: '&',
                deleteComment: '&',
                postComment: '&',
                root: '=?'
            },
        };
    }

}(angular));